import styled from 'styled-components';
import {MAIN_COLOR} from "../../components/globalThemes";

export const PhotoContainer = styled.div`    
    flex: 1;
    text-align: center;
`;

export const Photo = styled.img`
    max-width: 480px;
    max-height: 300px;
    border: 1px solid ${MAIN_COLOR};
    filter: saturate(0.7) contrast(1.4) brightness(1.1);
    margin-top: 50px;
    margin-left: 20px;
    margin-right: 20px;
    
    @media (max-width: 480px) {
        max-width: 320px;
        max-height: 200px;
    }
    
    @media (max-width: 340px) {
        max-width: 256px;
        max-height: 160px;
    }
`;

export const Caption = styled.p`
    font-family: Caveat, serif;
    color: black;
    font-size: 14px;  
`;
